import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {ModalService} from 'src/app/shared/services/modal.service';
import {ApiService} from 'src/app/shared/services/api.service';
import {UtilsService} from 'src/app/shared/services/utils.service';

import {banners, introSlider} from '../data';
import {SearchService} from '../../../shared/services/search.service';
import {environment} from '../../../../environments/environment';
import { DataService } from 'src/app/shared/services/data.service';
import { StoreService } from 'src/app/core/store/store.service';

@Component({
    selector: 'indiapicture-editorial',
    templateUrl: './editorial.component.html',
    styleUrls: ['./editorial.component.scss']
})

export class EditorialComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();

    products = [];
    posts = [];
    loaded = false;
    introSlider = introSlider;
    setting: any;
    slides = [];
    banners = banners;
    isMobile = false;
    currentUser = {isExclusive: false};

    showbanner = environment.showBanner;
    headerType: string = environment.headerType;
    constructor(public apiService: ApiService, public utilsService: UtilsService,
                private modalService: ModalService, private searchService: SearchService, 
                private dataService: DataService, private storageService: StoreService) {
        this.apiService.fetchSettings().subscribe(result => {
            this.setting = result.data;
            // console.log(this.setting);
            this.updateSetting();
            this.loaded = true; 
        });
        this.searchService = SearchService.getInstance();
        this.searchService.setSearch('');
        this.searchService.setCategory('editorial');
    }

    updateSetting() {
        this.slides = this.setting.editorial.slides.filter(item => item.published == 1);
        // this.banners = this.setting.editorial.banners;
    }

    showModal(event: Event) {
        event.preventDefault();
        this.modalService.showVideoModal();
    }

    ngOnInit(): void {

        if (window.innerWidth <= 500) {
            this.isMobile = true;
        }

        this.getCurrentUser();
    }

    getCurrentUser() {
        this.dataService.currentData$
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
         //  console.log('index component', data);
            if (data) {
            this.currentUser = data;
            }else{
                const user = this.storageService.getItem('currentUser');
             //  console.log('StorageService ==>', user);
                if (user) {
                 //  console.log('currentUser ==> ', user);
                    this.currentUser = user;
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
